<template>
  <div class="clearfix">
    <a-upload
      listType="picture-card"
      :fileList="fileList"
      @preview="handlePreview"
      @change="handleChange"
      name="file"
      :customRequest="handleUpload"
    >
      <div>
        <a-icon type="plus" />
        <div class="ant-upload-text">Upload</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
import { getFastDFSToken, saveFileUrl } from '@/api/file'
import { axios } from '@/utils/request'

export default {
  name: 'UploadImage',
  data () {
    return {
      previewVisible: false,
      previewImage: '',
      fileList: [],
      FDStoken: '',
      num: 0
    }
  },
  created () {
    const _this = this
    getFastDFSToken().then(res => {
      _this.FDStoken = res.token
      //
    })
  },
  methods: {
    handleChange ({ fileList }) {
      //debugger
      this.fileList = fileList
    },
    handleCancel () {
      this.previewVisible = false
    },
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handleUpload (data) {
      //debugger
      const uid = data.file.uid
      const formData = new FormData()
      const _this = this

      formData.append('file', data.file)
      formData.append('fastdfs_token', this.FDStoken)

      axios({
        method: 'post',
        url: '/fastdfs/upload',
        data: formData,
        timeout: 1000 * 60 * 2,
        onUploadProgress: event => {
          var index = _this.indexOf(uid)
          if (index == -1) return
          if (!_this.fileList[index]) return
          _this.$set(_this.fileList[index], 'percent', event.loaded / event.total)
        }
      }).then(res => {
        //debugger
        var index = _this.indexOf(uid)

        if (index == -1) return
        _this.$set(_this.fileList[index], 'status', 'done')
        _this.$set(_this.fileList[index], 'name', res.data.filename)
        _this.$set(_this.fileList[index], 'url', res.data.fileurl)
        _this.$set(_this.fileList[index], 'fileUid', res.data.fileUid)
        _this.$emit('upload_done')
      }).catch(err => {
        var index = _this.indexOf(uid)
        if (index == -1) return
        _this.$set(_this.fileList[index], 'status', 'error')
      })
    },

    indexOf (uid) {
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].uid == uid) return i
      }
      return -1
    },
    getFileUidArray () {
      const arr = []
      this.fileList.map(file => {
        if (file.status == 'done') {
          arr.push(file.fileUid)
        }
      })
      return arr
    }
  }
}
</script>
<style>
  /* you can make up upload button and sample style by using stylesheets */
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>
